<template>
  <section class="row align-items-center comp-translate">
    <div>
      <img
        @click="$refs.dpdLanguage.show()"
        v-if="this.$ml.current == 'portuguese'"
        src="../assets/svg/flags/br.svg"
        class="flag pointer img-circle"
        aria-haspopup="true"
        aria-expanded="false"
      />
      <img
        @click="$refs.dpdLanguage.show()"
        v-if="this.$ml.current == 'english'"
        src="../assets/svg/flags/us.svg"
        class="flag pointer img-circle"
        aria-haspopup="true"
        aria-expanded="false"
      />
      <img
        @click="$refs.dpdLanguage.show()"
        v-if="this.$ml.current == 'spanish'"
        src="../assets/svg/flags/es.svg"
        class="flag pointer img-circle"
        aria-haspopup="true"
        aria-expanded="false"
      />
    </div>

    <b-dropdown
      ref="dpdLanguage"
      dropleft
      split
      class="dropdown-links drop-language"
    >
      <div class="dropdown-item translate d-flex pt-3 pb-3">
        <a
          @click="alterLanguage('english')"
          id="flag-change-us"
          class="d-flex no pointer"
        >
          <div class="align-self-start">
            <img src="../assets/svg/flags/us.svg" />
          </div>
          <div class="pl-2 align-self-start no">
            <h3>English</h3>
            <p>Change primary language to English</p>
          </div>
        </a>
      </div>
      <div class="dropdown-divider m-0 mb-2"></div>
      <div class="dropdown-item translate d-flex pb-3">
        <a
          @click="alterLanguage('portuguese')"
          id="flag-change-br"
          class="d-flex no pointer"
        >
          <div class="align-self-start">
            <img src="../assets/svg/flags/br.svg" />
          </div>
          <div class="pl-2 align-self-start no">
            <h3>Português</h3>
            <p>Trocar o idioma padrão para Português</p>
          </div>
        </a>
      </div>
      <div class="dropdown-divider m-0 mb-2"></div>
      <div class="dropdown-item translate d-flex pt-3 pb-3">
        <a
          @click="alterLanguage('spanish')"
          id="flag-change-es"
          class="d-flex no pointer"
        >
          <div class="align-self-start">
            <img src="../assets/svg/flags/es.svg" />
          </div>
          <div class="pl-2 align-self-start no">
            <h3>Español</h3>
            <p>Cambiar idioma por defecto a Español</p>
          </div>
        </a>
      </div>
    </b-dropdown>
  </section>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      seconds: 50,
    };
  },

  mounted() {},

  methods: { 
    alterLanguage(language) {
      this.$refs.dpdLanguage.hide();
      this.$ml.change(language);
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.comp-translate {
  position: absolute;
  z-index: 9999;
  right: 30px;
  top: 30px;
}

.translate {
  border: none;
  width: 350px;
  white-space: normal;
  &:hover {
    background: white;
  }
  div {
    max-width: 100%;
  }
  img {
    margin-right: 10px;
    max-height: 42px;
    border-radius: 42px;
    width: auto;
  }
  p {
    font-size: 0.9rem;
    color: gray;
    font-weight: normal;
    margin: 0;
  }
  a {
    color: rgb(115, 12, 168);
    text-decoration: none;
    border: none;
  }
  a:hover {
    color: rebeccapurple !important;
    text-decoration: none;
    border: none;
  }
  h3 {
    font-size: 1rem;
    padding: 0;
    margin: 0;
  }
}

section {
  img {
    border-radius: 50%;
    height: 32px;
    padding: 0 0;
    margin-right: 10px;
  }
  .img-circle {
    box-shadow: 0 0 1em rgba(25, 5, 32, 0.715);
  }
}
</style>
